
<template>
<vx-card class="list-view-item overflow-hidden" v-on="$listeners">
    <template slot="no-body">
        <div class="vx-row item-details no-gutter">
            <!-- IMG COL -->
            <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center cursor-pointer" @click="navigate_to_detail_view(item)">
                <img src="https://www.ezzybills.com/wp-content/uploads/2018/08/2019-04-22_blue2.png" :alt="item.name" class="grid-view-img p-4" />
            </div>

            <!-- ITEM NAME & DESC COL -->
            <div class="vx-col sm:w-1/2">
                <div class="p-4 pt-6">
                    <slot name="item-meta">
                        <h6 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer" @click="navigate_to_detail_view(item)">
                            {{ item.name }}
                        </h6>
                        <p class="text-sm mb-4">
                            By
                            <span class="font-semibold cursor-pointer">{{
                  item.brand
                }}</span>
                        </p>
                        <p class="item-description text-sm">{{ item.description }}</p>
                    </slot>
                </div>
            </div>

            <!-- PURCHASE COL -->
            <div class="vx-col sm:w-1/4 w-full flex items-center sm:border border-0 border d-theme-border-grey-light border-r-0 border-t-0 border-b-0">
                <div class="p-4 flex flex-col w-full">
                    <div class="my-6">
                        <p class="mt-4 font-bold text-sm text-center">
                            <span class="text-primary">${{ item.price }} </span>
                        </p>

                        <span class="text-grey flex items-start justify-center mt-1">
                            <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4" />
                            <span class="text-sm ml-2">Free Shipping</span>
                        </span>
                    </div>

                    <!-- SLOT: ACTION BUTTONS -->
                    <slot name="action-buttons" />
                </div>
            </div>
            <div class="vx-col sm:w-1/4 w-full  flex items-center justify-center cursor-pointer mb-base">
                <slot name="action-buttonremove" />
            </div>
        </div>
    </template>
</vx-card>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    },
    computed: {},
    methods: {
        navigate_to_detail_view() {}
    }
};
</script>

<style lang="scss" scoped>
.list-view-item {

    .item-name,
    .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: 0.35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

        .grid-view-img {
            opacity: 0.9;
        }
    }
}
</style>
